export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7418.4f466222.jpg";